import dayjs from "dayjs";
import { MMM_YYYY, YYYY, Q_YYYY, DISPLAY_DATE } from "./date";

export const lastFiveYears = Array.from({ length: 5 }, (_, i) => i)
  .reverse()
  .map((i) => dayjs().subtract(i, "year").format("YYYY"));

export const REVENUE_BASIS = {
  PRODUCT: "PRODUCT",
  CUSTOMER: "CUSTOMER",
} as const;

export const PERIOD = {
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
  QUARTERLY: "QUARTERLY",
  TOTALS: "TOTALS",
} as const;

export type PeriodType = keyof typeof PERIOD;
export type PeriodValue = (typeof PERIOD)[keyof typeof PERIOD];

export const METRICS = {
  TOTAL: "TOTAL_STRIPE_REVENUE",
  MRR: "MONTHLY_RECURRING_REVENUE",
  ARR: "ANNUAL_RECURRING_REVENUE",
} as const;

export const PERIOD_DATE_FORMAT = {
  [PERIOD.MONTHLY]: MMM_YYYY,
  [PERIOD.QUARTERLY]: Q_YYYY,
  [PERIOD.YEARLY]: YYYY,
  [PERIOD.TOTALS]: DISPLAY_DATE,
};

export const OTHER_ITEM = {
  MERCHANT: "MERCHANT",
} as const;

export type OtherItemType = keyof typeof OTHER_ITEM;

export const NOT_SPECIFIED = "NOT_SPECIFIED";
